import { render, staticRenderFns } from "./hzbletter.vue?vue&type=template&id=6cb7d89d&"
import script from "./hzbletter.vue?vue&type=script&lang=ts&"
export * from "./hzbletter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports